import React, { useEffect, useState } from "react";
import "./LandingPage.css";
import Product from "./NewProduct";
import Product1 from "./SingleProduct";
import data_ from "./dataPoint/AllShopProducts";
import yoga from "./images/yoga.jpg";
import Breadcrumb from "./BreadCrumb";
import  axios from "axios";
import PageHeader from "./componets/PageHeader/PageHeader";


function LandingPage() {

  const [products, setProduct] = useState([]);
  
  useEffect(() => {
    const getData = async () => {
      const {data} = await axios.get("/api/products/")
      
// https://serene-channel-islands-78795.herokuapp.com/api/entries
      setProduct(data);
      console.log("axios data:", data);
    }

    getData();

    return () => {
      //
    }
  }, [])


  return (
    <div className="home">
          <PageHeader title="Shop" />


    
      <div >
        <Breadcrumb className="breadcrumb__" pagename="Shop" />
                {/* //featured items */}

        <h2 className="top__product__title">Featured Looks </h2>

      </div>
        {/* //featured items */}
      {/* fist 2 products */}
      <div className="home__row">
        <Product1
          key={1}
        id="2"
        price={390000}
        rating={5}
        image={yoga}
       title="A Nike Yoga Tank with a longer length and a little bit of stretch for extra coverage when you bend, stretch and balance. Dri-FIT technology wicks sweat to keep you dry.">
     
        </Product1>
        <Product1
          id="3"
          key={2}
        price={250000}
        rating={5}
        image={yoga}
       title="The Nike Yoga Fleece Cover Up made with soft thermal fabric for warm comfort. A relaxed, stretchy design lets you wear it as a V-neck or off the shoulder.">
     
        </Product1>
             
      </div>


      <div className="products__filter">
        <h3>All Looks</h3>
        <button>Filter</button>
      </div>      
          

       {/* fist 4 products */}

      <div className="home__row2">
        


        <ul className="product__list">
          {""}
          {data_.products.map((product) => (
            <li key={product._id}  className="product__list__"  >
              <Product
          id={product._id}
         price={product.price}
         rating={product.rating}
         image={product.image}
         closeUpOne={product.closeUpOne}
         closeUpTwo={product.closeUpTwo}
         desc={product.description}
         category={product.category}
         brand={product.brand}
         title={product.title_}>   
          
        </Product>

            </li>
          ))}
      </ul>


      </div>
  </div>
    
  );
}

export default LandingPage;
